function endpointIdentityInfo(row) {
    return row?.identityInfo ?? row?.identity_info ?? {};
}

export function endpointIdentityReason(row) {
    const raw = row?.identityCreationReason ?? row?.identity_creation_reason ??
        endpointIdentityInfo(row)?.creationReason ?? endpointIdentityInfo(row)?.creation_reason;
    if (raw === 1) return "REGISTRATION";
    if (raw === 2) return "IDENTITY_CONFLICT";
    if (raw === 3) return "CLONE_SPLIT";
    return String(raw ?? "").trim().toUpperCase().replace(/^ENDPOINT_IDENTITY_CREATION_REASON_/, "");
}

export function endpointIdentityBadge(row) {
    switch (endpointIdentityReason(row)) {
        case "CLONE_SPLIT":
            return {
                label: "Clone split",
                title: "Created after Origin detected two live copies using the same endpoint identity.",
            };
        case "IDENTITY_CONFLICT":
            return {
                label: "Identity conflict",
                title: "Registered separately because a matching endpoint could not be safely reclaimed.",
            };
        default:
            return null;
    }
}
